var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("SimpleTextPopup", {
    attrs: {
      title: _vm.$t("offlineDeposit"),
      hideRgtBtn: true,
      outsideScrollToBottom: _vm.outsideScrollToBottom,
      large: ""
    },
    on: { popupClose: _vm.hideDialog },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c(
              "v-layout",
              { attrs: { row: "", wrap: "" } },
              [
                _vm.isOrg
                  ? _c(
                      "v-flex",
                      { attrs: { xs3: "", lg1: "" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { color: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.addNewOffline()
                              }
                            }
                          },
                          [
                            _c("v-icon", [_vm._v("add")]),
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("offlineDeposit")) +
                                "\n        "
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-tabs",
              {
                attrs: { color: "transparent", "show-arrows": "" },
                model: {
                  value: _vm.tab,
                  callback: function($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab"
                }
              },
              [
                _c("v-tabs-slider", { attrs: { color: "primary" } }),
                _vm._v(" "),
                _vm._l(_vm.tabs, function(tabItem) {
                  return _c("v-tab", { key: tabItem }, [
                    _c("span", { staticClass: "tabItem" }, [
                      _vm._v(" " + _vm._s(_vm.$t(tabItem.toLowerCase())) + " ")
                    ])
                  ])
                }),
                _vm._v(" "),
                _c(
                  "v-tabs-items",
                  {
                    attrs: { touchless: "" },
                    model: {
                      value: _vm.tab,
                      callback: function($$v) {
                        _vm.tab = $$v
                      },
                      expression: "tab"
                    }
                  },
                  [
                    _c(
                      "v-tab-item",
                      { key: "active" },
                      [
                        _vm.tabs[_vm.tab] === "Active"
                          ? _c("v-data-table", {
                              staticClass: "elevation-2 myDense",
                              attrs: {
                                headers: _vm.headers,
                                items: _vm.offlineDeposits,
                                search: _vm.offlineSearch,
                                "rows-per-page-items": _vm.rowPerPage
                              },
                              on: {
                                "update:items": function($event) {
                                  _vm.offlineDeposits = $event
                                }
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "items",
                                    fn: function(props) {
                                      return [
                                        _c(
                                          "td",
                                          [
                                            _c(
                                              "v-layout",
                                              [
                                                _c("span", [
                                                  _vm._v(_vm._s(props.item.id))
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: { top: "" },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function(data) {
                                                            return [
                                                              _c(
                                                                "div",
                                                                _vm._g(
                                                                  {},
                                                                  data.on
                                                                ),
                                                                [
                                                                  props.item
                                                                    .isAdjustedBalance
                                                                    ? _c(
                                                                        "v-icon",
                                                                        {
                                                                          attrs: {
                                                                            color:
                                                                              "primary",
                                                                            small:
                                                                              ""
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "paid"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ],
                                                                1
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  },
                                                  [
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("adjusted")
                                                        )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(_vm._s(props.item.vendorName))
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(props.item.currencyType) +
                                              _vm._s(props.item.amount)
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(_vm._s(props.item.orgName))
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(props.item.offlineType)
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            staticStyle: {
                                              "word-break": "break-word",
                                              "max-width": "300px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(props.item.note) +
                                                "\n              "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(_vm._s(props.item.status))
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.toTimestampString(
                                                props.item.createTime
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { attrs: { "text-xs-center": "" } },
                                          [
                                            _c(
                                              "v-layout",
                                              { attrs: { row: "" } },
                                              [
                                                _c(
                                                  "v-flex",
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          dark: "",
                                                          color: "primary",
                                                          flat: ""
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.showCommentsDialog(
                                                              props.item
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("open")
                                                          ) +
                                                            "\n                      "
                                                        ),
                                                        _c("v-badge", {
                                                          staticClass:
                                                            "OfflineOpenBadge",
                                                          attrs: {
                                                            value: _vm.checkNewOfflineDeposit(
                                                              props.item
                                                            ),
                                                            color: "red"
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "badge",
                                                                fn: function() {
                                                                  return [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "badge"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "new"
                                                                            )
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                },
                                                                proxy: true
                                                              }
                                                            ],
                                                            null,
                                                            true
                                                          )
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  [
                                                    !_vm.isOrg
                                                      ? _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              dark: "",
                                                              color: "primary",
                                                              flat: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.showAdjustDialog(
                                                                  props.item
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t("adjust")
                                                              ) +
                                                                "\n                    "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                !_vm.activeWarehouse &&
                                                !_vm.isAdmin
                                                  ? _c(
                                                      "v-flex",
                                                      [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              flat: "",
                                                              disabled:
                                                                props.item
                                                                  .isAdjustedBalance,
                                                              color: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.cancelOfflineDeposit(
                                                                  props.item.id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t("cancel")
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                380700339
                              )
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-tab-item",
                      { key: "history" },
                      [
                        _vm.tabs[_vm.tab] === "History"
                          ? _c("PaginationController", {
                              attrs: {
                                refresh: _vm.paginationRefreshTrigger,
                                getDataActionName: "getHistoryOfflineDeposit",
                                historyLimit: _vm.historyLimit,
                                outsideScrollToBottom: _vm.popupToBottom
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "dataTable",
                                    fn: function() {
                                      return [
                                        _c("v-data-table", {
                                          attrs: {
                                            headers: _vm.headers,
                                            items: _vm.offlineDepositsHistory,
                                            "hide-actions": "",
                                            "disable-initial-sort": ""
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "items",
                                                fn: function(props) {
                                                  return [
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(props.item._key)
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          props.item.vendorName
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          props.item
                                                            .currencyType
                                                        ) +
                                                          _vm._s(
                                                            props.item.amount
                                                          )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          props.item.orgName
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            props.item
                                                              .offlineType
                                                          )
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticStyle: {
                                                          "word-break":
                                                            "break-word",
                                                          "max-width": "300px"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              props.item.note
                                                            ) +
                                                            "\n                  "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          props.item.status
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.toTimestampString(
                                                            props.item
                                                              .createTime
                                                          )
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.toTimestampString(
                                                            props.item
                                                              .lastModifiedTime
                                                          )
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          "text-xs-center": ""
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-layout",
                                                          {
                                                            attrs: { row: "" }
                                                          },
                                                          [
                                                            _c(
                                                              "v-flex",
                                                              [
                                                                _c(
                                                                  "v-btn",
                                                                  {
                                                                    attrs: {
                                                                      dark: "",
                                                                      color:
                                                                        "primary",
                                                                      flat: ""
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                        return _vm.showCommentsDialog(
                                                                          props.item
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "open"
                                                                        )
                                                                      ) +
                                                                        "\n                        "
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            3553951014
                                          )
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                814487441
                              ),
                              model: {
                                value: _vm.offlineDepositsHistory,
                                callback: function($$v) {
                                  _vm.offlineDepositsHistory = $$v
                                },
                                expression: "offlineDepositsHistory"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              2
            ),
            _vm._v(" "),
            _vm.commentsDialog
              ? _c("ChatRoom", {
                  ref: "chatRoom",
                  attrs: {
                    title: _vm.$t("caseOfflineDeposit"),
                    lastReadTime: _vm.offlineLastRead,
                    enableFileUpload: "",
                    docPath: ["depositRequests", _vm.OfflineDepositKey],
                    comments: _vm.offlineComments,
                    readOnly:
                      (_vm.offlineEdit && _vm.offlineEdit.status !== "open") ||
                      _vm.offlineEdit.isRemoved,
                    nickName:
                      _vm.activeWarehouse || _vm.isAdmin ? _vm.offlineAgent : ""
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "issue",
                        fn: function() {
                          return [
                            _c(
                              "v-card",
                              { attrs: { raised: "" } },
                              [
                                _c(
                                  "v-card-text",
                                  [
                                    _c(
                                      "v-layout",
                                      { staticClass: "cardTitle" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("requestID")) +
                                            ":" +
                                            _vm._s(
                                              _vm.offlineEdit.id ||
                                                _vm.offlineEdit._key
                                            )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      {
                                        staticClass: "cardTitle",
                                        staticStyle: {
                                          "overflow-wrap": "break-word"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(_vm.$t("createTime")) +
                                            ": " +
                                            _vm._s(
                                              _vm.toTimestampString(
                                                _vm.offlineEdit.createTime
                                              )
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.activeWarehouse
                                      ? _c(
                                          "v-layout",
                                          {
                                            staticClass: "cardTitle",
                                            staticStyle: {
                                              "overflow-wrap": "break-word"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(_vm.$t("organization")) +
                                                ": " +
                                                _vm._s(
                                                  _vm.offlineEdit.orgName
                                                ) +
                                                "\n            "
                                            )
                                          ]
                                        )
                                      : _c(
                                          "v-layout",
                                          {
                                            staticClass: "cardTitle",
                                            staticStyle: {
                                              "overflow-wrap": "break-word"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("vendor")) +
                                                ": " +
                                                _vm._s(
                                                  _vm.offlineEdit.vendorName
                                                )
                                            )
                                          ]
                                        ),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      { staticClass: "cardTitle" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("amount")) +
                                            ": " +
                                            _vm._s(
                                              _vm.offlineEdit.currencyType
                                            ) +
                                            _vm._s(_vm.offlineEdit.amount)
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      { staticClass: "cardTitle" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("offlineType")) +
                                            ":" +
                                            _vm._s(_vm.offlineEdit.offlineType)
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      {
                                        staticClass: "cardTitle",
                                        staticStyle: {
                                          "overflow-wrap": "break-word"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("note")) +
                                            ":" +
                                            _vm._s(_vm.offlineEdit.note)
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      { staticClass: "cardTitle" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("status")) +
                                            ":" +
                                            _vm._s(_vm.offlineEdit.status)
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      {
                                        staticClass: "cardTitle",
                                        staticStyle: {
                                          "overflow-wrap": "break-word"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(_vm.$t("lastModifiedTime")) +
                                            ": " +
                                            _vm._s(
                                              _vm.toTimestampString(
                                                _vm.offlineEdit
                                                  .lastModifiedTime ||
                                                  _vm.offlineEdit.createTime
                                              )
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    !!_vm.offlineEdit.transactionDocKeys
                                      ? _c(
                                          "v-layout",
                                          { staticClass: "cardTitle" },
                                          [
                                            _c("div", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.$t("adjustHistory")
                                                  ) +
                                                  ":\n              "
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              {
                                                staticStyle: {
                                                  "margin-top": "-14px"
                                                }
                                              },
                                              _vm._l(
                                                _vm.offlineEdit
                                                  .transactionDocKeys,
                                                function(docKey, index) {
                                                  return _c(
                                                    "div",
                                                    { key: index },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          staticStyle: {
                                                            cursor: "pointer",
                                                            "text-decoration":
                                                              "underline"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.openTransactionPopup(
                                                                docKey,
                                                                _vm.offlineEdit
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t("adjust")
                                                            ) +
                                                              _vm._s(index + 1)
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    (_vm.offlineEdit.uploadFiles || []).length
                                      ? _c(
                                          "v-layout",
                                          { attrs: { row: "", wrap: "" } },
                                          _vm._l(
                                            _vm.offlineEdit.uploadFiles,
                                            function(file, index) {
                                              return _c("FsFileChip", {
                                                key: "file" + index,
                                                staticClass: "ma-2",
                                                attrs: {
                                                  file: file,
                                                  width: "100%",
                                                  "aspect-ratio": "1.7"
                                                }
                                              })
                                            }
                                          ),
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        },
                        proxy: true
                      },
                      _vm.activeWarehouse || _vm.isAdmin
                        ? {
                            key: "operation",
                            fn: function() {
                              return [
                                _c(
                                  "v-layout",
                                  {
                                    attrs: {
                                      row: "",
                                      "no-wrap": "",
                                      "align-baseline": ""
                                    }
                                  },
                                  [
                                    _c(
                                      "v-flex",
                                      [
                                        _vm.offlineEdit.status == "open" &&
                                        !_vm.offlineEdit.isRemoved
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  small: "",
                                                  color: "primary"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.ProcessOfflineRequests(
                                                      "success"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("confirm"))
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      [
                                        _vm.offlineEdit.status == "open" &&
                                        !_vm.offlineEdit.isRemoved
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  small: "",
                                                  color: "primary"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.ProcessOfflineRequests(
                                                      "canceled"
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v(_vm._s(_vm.$t("cancel")))]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          }
                        : null
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: _vm.commentsDialog,
                    callback: function($$v) {
                      _vm.commentsDialog = $$v
                    },
                    expression: "commentsDialog"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.newOfflineDialog
              ? _c("FormSubmitPopup", {
                  attrs: {
                    title: _vm.$t("addDeposit"),
                    rightButtonText: _vm.$t("submit"),
                    rightMethod: _vm.submitOfflineDeposit,
                    rightButtonDisabled: !_vm.isEmpty,
                    hasAlert: "",
                    medium: ""
                  },
                  on: {
                    popupClose: function() {
                      return (_vm.newOfflineDialog = false)
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "input",
                        fn: function() {
                          return [
                            _c(
                              "v-container",
                              { staticClass: "offline" },
                              [
                                _c(
                                  "v-layout",
                                  {
                                    ref: "form",
                                    attrs: { "justify-space-between": "" }
                                  },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { md5: "", xl4: "" } },
                                      [
                                        _c(
                                          "v-radio-group",
                                          {
                                            attrs: { row: "" },
                                            model: {
                                              value: _vm.offlineType,
                                              callback: function($$v) {
                                                _vm.offlineType = $$v
                                              },
                                              expression: "offlineType"
                                            }
                                          },
                                          [
                                            _c("v-radio", {
                                              attrs: {
                                                label: _vm.$t("check"),
                                                value: "check"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("v-radio", {
                                              attrs: {
                                                label: "ACH",
                                                value: "ach"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("v-radio", {
                                              attrs: {
                                                label: _vm.$t("other"),
                                                value: "other"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      {
                                        staticClass: "AmountInput",
                                        attrs: { md4: "", xl4: "" }
                                      },
                                      [
                                        _c("v-text-field", {
                                          ref: "focus",
                                          attrs: {
                                            id: "balance_amount",
                                            label: _vm.$t("amount"),
                                            hint: _vm.$t("changeCurrency"),
                                            type: "number",
                                            rules: _vm.amountRules,
                                            disabled: _vm.submitting
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "prepend-inner",
                                                fn: function() {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          cursor: "pointer"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.transactionCurrency(
                                                              _vm.currency
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.currencyType
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                },
                                                proxy: true
                                              }
                                            ],
                                            null,
                                            false,
                                            3441319882
                                          ),
                                          model: {
                                            value: _vm.amount,
                                            callback: function($$v) {
                                              _vm.amount = _vm._n($$v)
                                            },
                                            expression: "amount"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  [
                                    _c("v-textarea", {
                                      attrs: {
                                        label: _vm.$t("note"),
                                        outline: "",
                                        rules: _vm.noteRules,
                                        counter: 200,
                                        "auto-grow": ""
                                      },
                                      model: {
                                        value: _vm.note,
                                        callback: function($$v) {
                                          _vm.note = $$v
                                        },
                                        expression: "note"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  [
                                    _c("UploadFileWidget", {
                                      ref: "fileUploader",
                                      attrs: { type: "file", maxFiles: 9 },
                                      model: {
                                        value: _vm.uploadFiles,
                                        callback: function($$v) {
                                          _vm.uploadFiles = $$v
                                        },
                                        expression: "uploadFiles"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    428003365
                  ),
                  model: {
                    value: _vm.newOfflineDialog,
                    callback: function($$v) {
                      _vm.newOfflineDialog = $$v
                    },
                    expression: "newOfflineDialog"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.adjustBalanceDialog
              ? _c("AdjustBalancePopup", {
                  attrs: {
                    adjustment: _vm.adjustBalance,
                    actionFunc: _vm.addAdjustBalance
                  },
                  model: {
                    value: _vm.adjustBalanceDialog,
                    callback: function($$v) {
                      _vm.adjustBalanceDialog = $$v
                    },
                    expression: "adjustBalanceDialog"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showTransactionPopup
              ? _c("TransactionDetailsPopup", {
                  attrs: { transaction: _vm.transaction },
                  model: {
                    value: _vm.showTransactionPopup,
                    callback: function($$v) {
                      _vm.showTransactionPopup = $$v
                    },
                    expression: "showTransactionPopup"
                  }
                })
              : _vm._e()
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51ab57b1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51ab57b1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OfflineDepositPopup.vue
// module id = null
// module chunks = 